// extracted by mini-css-extract-plugin
export default {"product_img_container":"ProductImage_product_img_container__uN2wt"};